class Textarea extends React.Component {
  render () {
    return (
      <li className="section__item">
        <h3 className="section__item-title" id="textarea">
          Texarea
          <span className="section__item-docs">
            Documentation: <a href="docs/scss#elements-mixin-textarea" target="_blank">SCSS</a>
          </span>
        </h3>
        <div className="section__demo">
         <Collapser>
            <div className="demo">
              <h4 className="demo__title">Textareas</h4>
              <div className="demo__code">
                <CodeBlock lang="html">
                {`
<div class="textarea-demo">
  <textarea class="dark">
    Dark themed textarea
  </textarea>

  <textarea class="dark-disabled" disabled>
    Dark themed textarea - disabled
  </textarea>

  <textarea class="light">
    Light themed textarea - non resizable
  </textarea>

  <textarea class="light-disabled" disabled>
    Light themed textarea - disabled
  </textarea
</div>
                `}
                </CodeBlock>
                <CodeBlock lang="scss">
                {`
.textarea-demo {
  .dark {
    @include textarea();
  }

  .light {
    @include textarea(light, false);
  }

  .dark-disabled {
    @include textarea($disabled: true);
  }

  .light-disabled {
    @include textarea(light, $disabled:true);
  }
}
                `}
                </CodeBlock>
              </div>
              <div className="demo__output">
                <Output>
                  <div className="textarea-demo">
                    <textarea className="dark">
                      Dark themed textarea
                    </textarea>

                    <textarea className="dark-disabled" disabled={true}>
                      Dark themed textarea - disabled
                    </textarea>

                    <textarea className="light">
                      Light themed textarea - non resizable
                    </textarea>

                    <textarea className="light-disabled" disabled={true}>
                      Light themed textarea - disabled
                    </textarea>
                  </div>
                </Output>
              </div>
            </div>
          </Collapser>
        </div>
      </li>
    );
  }
};
